export class CrudState {
    error = {};
    success = {};
    isLoading = false;
    dataList = [];
    dataItem = {};
    total = 0;
    id = 0;
}
